import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { MDPMeetingDetails } from '.';
import { APICONFIG } from '@config/api.config';

interface IMDPMMeetingDetails {
	mutate: UseMutateFunction<MDPMeetingDetails, Error, MDPMeetingDetails, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useMDPMMeetingMutation = (): IMDPMMeetingDetails => {
	const postMDPMMeetingData = async (meetingFormData: MDPMeetingDetails): Promise<MDPMeetingDetails> => {
		const url = `${APICONFIG.MDP_MEETINGS_DETAILS}/`;
		return await APIService.postData<MDPMeetingDetails>(url, meetingFormData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: postMDPMMeetingData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
